import { faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import "./Edit_Non_Work.css";
import Success_Toster from "../../../../../../../common/common_modal/success_toster/Success_Toster";
import { useState } from "react";
function Edit_Non_Work({ onCancel ,handleClose }) {
 const [success, setSuccess] = useState(false);

  // ⏱ auto hide success toaster after 3 sec
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        setSuccess(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [success]);
  return (
    <section className="Legal_Entity_Form">
      <div className="white_container customer_section">
        <div className="row">
          {/* Record No */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Record No.</Form.Label>
              <Form.Control placeholder="Enter NCR [Year]/[Sequential Number]" />
            </Form.Group>
          </div>

          {/* Date Raised */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Date Raised</Form.Label>
              <Form.Control placeholder="Enter Date" />
            </Form.Group>
          </div>

          {/* Dept / Area */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Dept./Area</Form.Label>
              <Form.Select>
                <option>Dept./Area</option>
                <option>Lab Area</option>
                <option>Quality</option>
                <option>Production</option>
              </Form.Select>
            </Form.Group>
          </div>

          {/* Non-Conformity Statement */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Non-Conformity Statement</Form.Label>
              <Form.Control placeholder="Enter Statement" />
            </Form.Group>
          </div>

          {/* Clause / Document Violated */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Clause/Document Violated</Form.Label>
              <Form.Control placeholder="eg. ISO/IEC 17025:2017, Clause 7.5" />
            </Form.Group>
          </div>

          {/* Initial Action Taken */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Initial Action Taken</Form.Label>
              <Form.Control placeholder="Action Taken" />
            </Form.Group>
          </div>

          {/* Root Cause Analysis */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Root Cause Analysis</Form.Label>
              <Form.Control placeholder="Root Cause Analysis" />
            </Form.Group>
          </div>

          {/* Corrective Action Proposed */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Corrective Action Proposed</Form.Label>
              <Form.Control placeholder="Corrective Action Proposed" />
            </Form.Group>
          </div>

          {/* Responsibility */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Responsibility</Form.Label>
              <Form.Control placeholder="Responsibility" />
            </Form.Group>
          </div>

          {/* Target Date */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Target Date</Form.Label>
              <Form.Control placeholder="Enter Date" />
            </Form.Group>
          </div>

          {/* Attached File (Optional) */}
          <div className="col-md-4">
            <Form.Group className="form_group file_field">
              <Form.Label>Attached File (Optional)</Form.Label>
              <div className="absolute_fields">
                <Form.Control placeholder="Upload File" disabled />
                <div className="upload_icon_holder">
                  <FontAwesomeIcon icon={faUpload} className="upload_icon" />
                </div>
              </div>
            </Form.Group>
          </div>

          {/* Action Taken */}
          <div className="col-md-12">
            <Form.Group className="form_group">
              <Form.Label>Action Taken:</Form.Label>

              <div className="row action_taken_group">
                <div className="col-md-4">
                  <Form.Check
                    type="radio"
                    name="actionTaken"
                    label="Pending / Forwarded to Regulator/Company"
                  />
                  <p className="radio_help_text">
                    Your complaint has been successfully registered & sent to
                    the concerned party for resolution.
                  </p>
                </div>

                <div className="col-md-4">
                  <Form.Check
                    type="radio"
                    name="actionTaken"
                    label="Action Taken Report (ATR) Received"
                  />
                  <p className="radio_help_text">
                    The company or agency has submitted their report on what
                    action they have taken.
                  </p>
                </div>

                <div className="col-md-4">
                  <Form.Check
                    type="radio"
                    name="actionTaken"
                    label="Resolved / Satisfied"
                  />
                  <p className="radio_help_text">
                    The issue has been sorted out to your satisfaction (often
                    after you confirm the resolution).
                  </p>
                </div>

                <div className="col-md-4 mt-3">
                  <Form.Check
                    type="radio"
                    name="actionTaken"
                    label="Disposed"
                  />
                  <p className="radio_help_text">
                    The case is closed. This could be because it was resolved,
                    was not taken up, or you did not respond to an inquiry.
                  </p>
                </div>
              </div>
            </Form.Group>
          </div>

          {/* Remark */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Remark</Form.Label>
              <Form.Control placeholder="Enter Remark" />
            </Form.Group>
          </div>
        </div>

        {/* Buttons */}
         <div className="permission_btn_holder">
            {success ? (
              <Success_Toster successText="Save Audit Successfully!" />
            ) : (
              <>
                <Button type="button" className="permission_btn No_btn">
                  Cancel
                </Button>

                <Button
                  type="button"
                  className="permission_btn Yes_btn"
                  onClick={() => setSuccess(true)}
                >
                  Save
                </Button>
              </>
            )}
          </div>
      </div>
    </section>
  );
}

export default Edit_Non_Work;
